import {
  Mutation,
  SubmitChargeCardPaymentOptionInput,
} from '@varo/graphql-schema-types';
import submitChargeCardPaymentOption from 'services/graphql/mutations/Believe/PayCard';
import { useMutation } from 'urql';

export const useSubmitPayCard = () => {
  const [{ fetching, error }, executeMutation] = useMutation<Mutation>(
    submitChargeCardPaymentOption,
  );

  const submitPayCard = async (
    idempotencyId: string,
    id: string,
    paymentDate: string,
  ) => {
    const input: SubmitChargeCardPaymentOptionInput = {
      id,
      paymentDate,
    };
    const response = await executeMutation({ idempotencyId, input });
    return response?.data?.submitChargeCardPaymentOption?.__typename;
  };

  return {
    fetching,
    error,
    submitPayCard,
  };
};
